export default "__VITE_ASSET__DpVmQChc__"